import type { FC } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

import { useNotifications } from '../../../modules/hooks';

export const SimpleToasts: FC = () => {
  const { simpleToasts = { show: false }, setSimpleToasts } = useNotifications()!;
  const { message, type, show, delay } = simpleToasts;

  const toggleShow = () => setSimpleToasts({ show: !show });

  return (
    <ToastContainer position="top-center" className="position-fixed mt-24px">
      <Toast delay={delay || 10000} show={show} bg={type} onClose={toggleShow} autohide>
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};
